import { ToasterComponent, ToasterProvider } from "@gravity-ui/uikit";
import { PropsWithChildren } from "react";
import { toaster } from "src/util/toastHandler";

import { HeadProvider } from "./HeadProvider";
import { I18nProvider } from "./I18nProvider";
import { ThemeProvider } from "./ThemeProvider";

export const Providers = ({ children }: PropsWithChildren) => {
  return (
    <ThemeProvider>
      <HeadProvider>
        <I18nProvider>
          <ToasterProvider toaster={toaster}>
            {children}
            <ToasterComponent />
          </ToasterProvider>
        </I18nProvider>
      </HeadProvider>
    </ThemeProvider>
  );
};
